// extracted by mini-css-extract-plugin
export default {"main":"App_main__nhgh3","mainOuter":"App_mainOuter__0y93A","mainInner":"App_mainInner__sTshl"};